module.exports = __webpack_public_path__ + "img/undraw_Steps_re_odoy.c57645a7.svg";